export function formatNumber(value) {
  return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function formatInteger(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
